import styled from 'styled-components';

// Loading Container
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  color: #cbd5e1;
  font-size: 16px;
  background: ${(props) =>
    props.theme?.name === 'dark'
      ? props.theme.colors.background.primary
      : '#f2f2f2'};
  width: 100%;
  min-height: 100vh;
`;

// Pagination
export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 32px;
  border-top: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.05)'
        : 'rgba(0,0,0,0.08)'};

  @media (max-width: 768px) {
    padding: 16px;
    gap: 4px;
  }
`;

export const PageBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 12px;
  background: ${(props) =>
    props.active
      ? props.theme?.colors?.primary || '#FA4616'
      : props.theme.name === 'dark'
      ? 'transparent'
      : 'white'};
  color: ${(props) =>
    props.active
      ? 'white'
      : props.theme.name === 'dark'
      ? props.theme.colors?.text?.secondaryMuted || '#94A3B8'
      : '#64748b'};
  border: 1px solid
    ${(props) =>
      props.active
        ? props.theme?.colors?.primary || '#FA4616'
        : props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  outline: none;

  &:hover:not(:disabled) {
    background: ${(props) =>
      props.active
        ? '#E03A0D'
        : props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.05)'
        : 'rgba(0,0,0,0.03)'};
    border-color: ${(props) =>
      props.active
        ? '#E03A0D'
        : props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.2)'
        : 'rgba(0,0,0,0.15)'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    min-width: 28px;
    height: 28px;
    padding: 0 8px;
    font-size: 13px;
  }
`;

export const PageEllipsis = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.text?.secondaryMuted || '#94A3B8'
      : '#94a3b8'};
  font-size: 14px;
  user-select: none;

  @media (max-width: 768px) {
    min-width: 28px;
    height: 28px;
    font-size: 13px;
  }
`;

// Main Container with theme-aware background
export const Container = styled.div`
  background: ${(props) =>
    props.theme?.name === 'dark'
      ? props.theme.colors.background.primary
      : '#f2f2f2'};
  min-height: 100vh;
  padding: 48px 32px;
  font-family: Arial, -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Ubuntu, sans-serif;

  @media (max-width: 768px) {
    padding: 16px;
    overflow-x: hidden;
  }
`;

// Customer Header Section
export const CustomerHeaderContainer = styled.div`
  background: ${(props) =>
    props.theme.card?.background ||
    (props.theme.name === 'dark' ? 'rgba(255,255,255,0.05)' : 'white')};
  border: 1px solid
    ${(props) =>
      props.theme.card?.border ||
      (props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgb(226, 232, 240)')};
  border-radius: 8px;
  box-shadow: ${(props) =>
    props.theme.card?.shadow || 'rgba(0, 0, 0, 0.1) 0px 1px 3px'};
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px;
  padding: 32px;
  margin-bottom: 30px;
  backdrop-filter: ${(props) =>
    props.theme.name === 'dark' ? 'blur(20px)' : 'none'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;

  @media (max-width: 768px) {
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const CustomerHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
`;

export const CustomerAvatarWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const CustomerAvatar = styled.div`
  width: 80px;
  height: 80px;
  background: rgba(250, 70, 22, 0.1);
  border: 2px solid ${(props) => props.theme?.colors?.primary || '#fa4616'};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  flex-shrink: 0;
`;

export const CustomerInfo = styled.div`
  flex: 1;
`;

export const CustomerName = styled.h1`
  font-size: 32px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : 'props.theme.colors.blueBlack'};
  letter-spacing: -0.5px;
  margin-bottom: 8px;
`;

export const CustomerMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
`;

export const CustomerMetaItem = styled.span`
  color: #94a3b8;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;

  a {
    color: #94a3b8;
    text-decoration: none;
    transition: color 0.15s ease;

    &:hover {
      color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
      text-decoration: underline;
    }
  }
`;

export const CustomerHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const LifetimeValue = styled.div`
  text-align: center;
  padding: 13px 21px;
  background: rgba(250, 70, 22, 0.05);
  border: 1px solid rgba(250, 70, 22, 0.2);
  border-radius: 8px;
`;

export const LifetimeAmount = styled.div`
  font-size: 33px;
  font-weight: 700;
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  letter-spacing: -1px;
  line-height: 1;
  margin-bottom: 4px;
`;

export const LifetimeLabel = styled.div`
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #94a3b8;
`;

export const LoyalBadge = styled.span`
  background: linear-gradient(135deg, #ffd700 0%, #ffa500 100%);
  color: #1a1a2e;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;

// Dashboard Layout
export const DashboardLayout = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 24px;
  align-items: start;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  overflow-x: hidden;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 768px) {
    display: block;
    width: 100%;
    max-width: 100%;
  }
`;

export const MainContent = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

export const Sidebar = styled.div`
  @media (max-width: 1200px) {
    position: static;
    margin-top: 24px;
  }
`;

// Metrics Grid with horizontal scroll on mobile
export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 30px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    gap: 10px;
    margin: 0 0 24px 0;
    padding: 0;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const MetricCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  transition: all 0.15s ease;
  backdrop-filter: blur(20px);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
  }
`;

export const MetricValue = styled.div`
  font-size: 36px;
  font-weight: 700;
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  letter-spacing: -1px;
  line-height: 1;
  margin-bottom: 8px;
`;

export const MetricLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #94a3b8;
`;

export const MetricChange = styled.div`
  font-size: 13px;
  font-weight: 500;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: ${(props) =>
    props.positive ? props.theme?.colors?.success || '#22C55E' : '#DC2626'};

  &:before {
    content: '${(props) => (props.positive ? '↑' : '↓')}';
  }
`;

// Transaction Card
export const TransactionCard = styled.div`
  background: ${(props) =>
    props.theme.card?.background ||
    (props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.05)'
      : 'rgba(255,255,255,0.95)')};
  border: 1px solid
    ${(props) =>
      props.theme.card?.border ||
      (props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgb(226, 232, 240)')};
  border-radius: 8px;
  box-shadow: ${(props) =>
    props.theme.card?.shadow || 'rgba(0, 0, 0, 0.1) 0px 1px 3px'};
  box-shadow: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(0, 0, 0, 0.1) 0px 1px 3px'
      : 'rgba(0, 0, 0, 0.05) 0px 1px 3px'};
  backdrop-filter: ${(props) =>
    props.theme.name === 'dark' ? 'blur(20px)' : 'none'};
  overflow: hidden;
  transition: box-shadow 0.15s ease;
  width: 100%;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 768px) {
    padding: 0;
    margin: 0;
    width: 100%;
    border-radius: 12px;
  }
`;

export const TransactionHeader = styled.div`
  padding: 24px 32px;
  border-bottom: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.08)'};

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const TransactionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : 'props.theme.colors.blueBlack'};
  margin: 0;
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 12px;
  padding: 24px 32px;
  flex-wrap: wrap;
  border-bottom: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.05)'
        : 'rgba(0,0,0,0.08)'};

  @media (max-width: 768px) {
    padding: 16px;
    gap: 8px;
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Tab = styled.button`
  padding: 8px 16px;
  background: ${(props) => {
    if (props.active) {
      return 'rgba(250,70,22,0.08)';
    }
    return props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.06)'
      : 'rgba(255,255,255,1)';
  }};
  border: 1px solid
    ${(props) => {
      if (props.active) {
        return props.theme?.colors?.primary || '#FA4616';
      }
      return props.theme.name === 'dark'
        ? props.theme?.colors?.['border-button'] || 'rgba(255,255,255,0.15)'
        : 'rgba(0,0,0,0.15)';
    }};
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => {
    if (props.active) {
      return props.theme?.colors?.primary || '#FA4616';
    }
    return props.theme.name === 'dark' ? '#94a3b8' : '#64748b';
  }};
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    ${(props) =>
      !props.active &&
      `
      background: rgba(250,70,22,0.08);
      color: ${(props) => props.theme?.colors?.primary || '#FA4616'};
      border-color: ${(props) => props.theme?.colors?.primary || '#FA4616'};
    `}
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 13px;
    flex-shrink: 0;
  }
`;

// Transaction List
export const TransactionList = styled.div`
  padding: 0 24px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const TransactionItem = styled.div`
  /* Variation 4: Card with Status Indicators */
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#ffffff'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0, 0, 0, 0.08)'};
  border-left: 4px solid ${(props) => props.theme?.colors?.primary || '#fa4616'};
  border-radius: 12px;
  padding: 0;
  margin-bottom: 16px;
  overflow: hidden;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    background: ${(props) =>
      props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#f8f9fa'};
    transform: scale(1.01);
  }

  /* Mobile: Clean Card Style */
  @media (max-width: 768px) {
    background: ${(props) =>
      props.theme.name === 'dark' ? 'rgba(30, 41, 59, 0.5)' : '#ffffff'};
    border: 1px solid
      ${(props) =>
        props.theme.name === 'dark'
          ? 'rgba(255, 255, 255, 0.1)'
          : 'rgba(0, 0, 0, 0.1)'};
    border-radius: 12px;
    padding: 0;
    margin-bottom: 12px;
    backdrop-filter: blur(20px);
  }
`;

// StatusBar component removed - using border-left on TransactionItem instead

export const TransactionItemHeader = styled.div`
  /* Variation 4: Header with Status Bar */
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 20px 24px;
  position: relative;

  /* Mobile: Clean Header */
  @media (max-width: 768px) {
    padding: 16px;
    align-items: center;
  }
`;

export const TransactionItemLeft = styled.div`
  /* Variation 4: Left Section */
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: 12px;

  /* Mobile: Clean Left Section */
  @media (max-width: 768px) {
    flex: 1;
    min-width: 0;
    display: block;
    margin-left: 0;
  }
`;

export const DateBadge = styled.div`
  /* Variation 4: Date Badge - Transparent Orange Background */
  background: rgba(250, 70, 22, 0.1);
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  padding: 8px 10px;
  border-radius: 6px;
  text-align: center;
  min-width: 50px;
  font-weight: 600;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  margin-right: 0;

  .date-day {
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 2px;
  }

  .date-month {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.05em;
    line-height: 1;
  }

  /* Mobile: Clean Date Style */
  @media (max-width: 768px) {
    background: transparent;
    border: none;
    padding: 0;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    flex-direction: row;
    gap: 4px;
    min-width: auto;

    .date-day {
      font-size: 11px;
      margin-bottom: 0;
    }

    .date-month {
      font-size: 11px;
    }
  }
`;

export const DateMonth = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  letter-spacing: 0.05em;
`;

export const DateDay = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  line-height: 1;
`;

export const TransactionInfo = styled.div`
  flex: 1;
`;

export const EventName = styled.div`
  /* Desktop: Variation 1 Event Name */
  font-size: 17px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : 'props.theme.colors.blueBlack'};
  margin-bottom: 4px;
  max-width: 600px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  line-height: 1.3;

  /* Mobile: Clean Event Name */
  @media (max-width: 768px) {
    font-size: 17px;
    font-weight: 500;
    color: ${(props) =>
      props.theme.name === 'dark' ? '#ffffff' : 'props.theme.colors.blueBlack'};
    max-width: 100%;
    overflow-wrap: break-word;
    word-wrap: break-word;
    line-height: 1.3;
  }
`;

export const EventSummary = styled.div`
  /* Desktop: Variation 1 Meta Info - Stacked */
  font-size: 14px;
  color: ${(props) => (props.theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;

  /* Mobile: Hide on mobile */
  @media (max-width: 768px) {
    display: none;
  }
`;

export const TransactionRightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`;

export const StatusBadge = styled.div`
  background: ${(props) => {
    if (props.status === 'cancelled') return '#ef4444';
    if (props.status === 'postponed') return '#f59e0b';
    return '#6b7280';
  }};
  color: white;
  border-radius: 12px;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: ${(props) => {
    if (props.status === 'cancelled') return '0 2px 8px rgba(239, 68, 68, 0.5)';
    if (props.status === 'postponed')
      return '0 2px 8px rgba(245, 158, 11, 0.5)';
    return '0 2px 8px rgba(107, 114, 128, 0.5)';
  }};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 10px;
    padding: 3px 10px;
  }
`;

export const TransactionAmount = styled.div`
  /* Variation 4: Amount */
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => props.theme?.colors?.success || '#22c55e'};

  /* Mobile: Clean Amount */
  @media (max-width: 768px) {
    font-size: 20px;
    font-weight: 600;
    color: ${(props) => props.theme?.colors?.success || 'rgb(34, 197, 94)'};
    margin-left: 0;
  }
`;

export const ExpandIcon = styled.svg`
  width: 16px;
  height: 16px;
  opacity: 0.5;
  transition: transform 0.2s;
  flex-shrink: 0;
  color: currentColor;

  &.desktop-chevron {
    display: block;
    transform: ${(props) => (props.expanded ? 'rotate(180deg)' : 'rotate(0)')};
    @media (max-width: 768px) {
      display: none;
    }
  }

  &.mobile-chevron {
    display: none;
    @media (max-width: 768px) {
      display: block;
      width: 20px;
      height: 20px;
      color: ${(props) =>
        props.theme.name === 'dark'
          ? props.theme.colors?.text?.secondaryMuted || '#94A3B8'
          : '#64748b'};
      transform: ${(props) => (props.expanded ? 'rotate(90deg)' : 'rotate(0)')};
      margin-left: 12px;
    }
  }
`;

export const TransactionDetails = styled.div`
  /* Variation 4: Details Container */
  padding: 24px;
  border-top: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0, 0, 0, 0.08)'};

  /* Mobile: Clean Details */
  @media (max-width: 768px) {
    padding: 20px 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

export const DetailColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${(props) =>
    props.alignRight &&
    `
    align-items: flex-end;
    text-align: right;
  `}
`;

export const TicketsList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 8px 0 0 0;
  padding: 0;
`;

export const TicketItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : 'rgba(0, 0, 0, 0.03)'};
  border-radius: 6px;
  font-size: 14px;
`;

export const TicketQuantity = styled.span`
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  font-weight: 600;
  margin-right: 8px;
`;

export const TicketType = styled.span`
  color: ${(props) => (props.theme.name === 'dark' ? '#e2e8f0' : '#334155')};
`;

export const TicketPrice = styled.span`
  color: ${(props) => props.theme?.colors?.success || '#22c55e'};
  font-weight: 500;
  white-space: nowrap;
`;

export const DetailSection = styled.div`
  /* Desktop: Variation 1 Detail Grid */
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  /* Mobile: Clean Detail Grid */
  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 16px;
  }
`;

export const DetailRowSimple = styled.div`
  /* Desktop: Variation 1 Detail Item */
  flex: 1;
  min-width: 140px;
  display: flex;
  flex-direction: column;

  /* Mobile: Clean Detail Item */
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;

export const DetailRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 40px;
  margin-bottom: 16px;

  &.mobile-show-tickets {
    display: none;

    @media (max-width: 768px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
    }
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const DetailItem = styled.div`
  display: flex;
  gap: 8px;
  font-size: 14px;
  align-items: flex-start;
`;

export const DetailLabel = styled.div`
  /* Desktop: Variation 1 Label */
  font-size: 12px;
  text-transform: uppercase;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.text?.secondaryMuted || '#94A3B8'
      : '#64748b'};
  margin-bottom: 4px;
  font-weight: 700;
  letter-spacing: 0.05em;

  /* Mobile: Clean Label */
  @media (max-width: 768px) {
    font-size: 10px;
    text-transform: uppercase;
    color: ${(props) =>
      props.theme.name === 'dark'
        ? props.theme.colors?.text?.secondaryMuted || '#94A3B8'
        : '#64748b'};
    font-weight: 700;
    letter-spacing: 0.05em;
  }
`;

export const DetailValue = styled.div`
  /* Desktop: Variation 1 Value */
  font-size: 15px;
  color: ${(props) => (props.theme.name === 'dark' ? '#e2e8f0' : '#1e293b')};
  word-break: break-word;

  /* Mobile: Clean Value */
  @media (max-width: 768px) {
    font-size: 14px;
    color: ${(props) => (props.theme.name === 'dark' ? '#cbd5e1' : '#334155')};
    font-weight: 400;
    line-height: 1.4;
  }
`;

export const DetailActions = styled.div`
  /* Desktop: Variation 1 Action Container */
  display: flex;
  gap: 8px;
  margin-top: 12px;
  justify-content: flex-end;

  /* Mobile: Clean Action Container */
  @media (max-width: 768px) {
    display: flex;
    gap: 8px;
    margin-top: 16px;
  }
`;

export const ViewDetailsButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  padding: 10px 20px;
  background: transparent;
  border: 1px solid rgba(250, 70, 22, 0.3);
  border-radius: 8px;
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: rgba(250, 70, 22, 0.1);
    border-color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
    transform: translateX(4px);
  }

  &:after {
    content: '→';
    transition: transform 0.15s ease;
  }

  &:hover:after {
    transform: translateX(4px);
  }
`;

// Legacy export for compatibility
export const DetailGroup = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
`;

// Sidebar Cards Base
const SidebarCard = styled.div`
  background: ${(props) =>
    props.theme.card?.background ||
    (props.theme.name === 'dark' ? 'rgba(255,255,255,0.05)' : 'white')};
  border: 1px solid
    ${(props) =>
      props.theme.card?.border ||
      (props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgb(226, 232, 240)')};
  border-radius: 8px;
  box-shadow: ${(props) =>
    props.theme.card?.shadow || 'rgba(0, 0, 0, 0.1) 0px 1px 3px'};
  padding: 24px;
  margin-bottom: 30px;
  backdrop-filter: ${(props) =>
    props.theme.name === 'dark' ? 'blur(20px)' : 'none'};
`;

// Quick Stats
export const QuickStatsCard = styled(SidebarCard)`
  margin-top: 0;

  @media (min-width: 1201px) {
    margin-top: 0;
  }
`;

export const QuickStatsTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : 'props.theme.colors.blueBlack'};
  margin-bottom: 24px;
`;

export const QuickStatItem = styled.div`
  display: flex;
  align-items: start;
  gap: 12px;
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const QuickStatIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(250, 70, 22, 0.08)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark' ? 'transparent' : 'rgba(250, 70, 22, 0.2)'};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
  flex-shrink: 0;
  transition: all 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
    opacity: 1;
    color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  }
`;

export const QuickStatContent = styled.div`
  flex: 1;
`;

export const QuickStatLabel = styled.div`
  color: ${(props) => (props.theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  font-size: 13px;
  letter-spacing: 0.08em;
  margin-bottom: 8px;
  font-weight: 700;
`;

export const QuickStatValue = styled.div`
  color: ${(props) =>
    props.color || (props.theme.name === 'dark' ? '#e2e8f0' : '#1e293b')};
  font-size: ${(props) => props.size || '24px'};
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 4px;
`;

export const QuickStatSubtext = styled.div`
  color: ${(props) => (props.theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  font-size: 13px;
  margin-top: 4px;
`;

// Helper function to get segment colors
const getSegmentColor = (segment) => {
  const segmentColors = {
    super_fan: '#22C55E',
    regular_fan: '#3B82F6',
    casual_fan: '#06B6D4',
    occasional: '#A78BFA',
    first_timer: '#F59E0B',
    inactive: '#DC2626',
  };
  return segmentColors[segment] || '#fa4616';
};

export const SegmentBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  background: ${(props) => {
    const color = getSegmentColor(props.segment);
    return `${color}26`; // 15% opacity
  }};
  border: 1px solid
    ${(props) => {
      const color = getSegmentColor(props.segment);
      return `${color}4D`; // 30% opacity
    }};
  color: ${(props) => getSegmentColor(props.segment)};
  font-size: 14px;
  font-weight: 600;
  border-radius: 20px;
`;

// Contact Info
export const ContactInfoCard = styled(SidebarCard)``;

export const ContactInfoTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 20px;
`;

export const ContactInfoItem = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ContactLabel = styled.div`
  color: #94a3b8;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
`;

export const ContactValue = styled.div`
  color: #ffffff;
  font-size: 14px;
`;

// Activity Card
export const ActivityCard = styled(SidebarCard)``;

export const ActivityTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 20px;
`;

export const ActivityItem = styled.div`
  display: flex;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);

  &:last-child {
    border-bottom: none;
  }
`;

export const ActivityDate = styled.div`
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  min-width: 50px;
`;

export const ActivityDescription = styled.div`
  color: #cbd5e1;
  font-size: 14px;
  flex: 1;
`;

// Patterns Card
export const PatternsCard = styled(SidebarCard)``;

export const PatternsTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : 'props.theme.colors.blueBlack'};
  margin: 0;
  line-height: 1.2;
`;

export const FilterPills = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const FilterPill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(255, 255, 255, 1)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.08)'};
  border-radius: 20px;
  font-size: 14px;
  color: ${(props) => (props.theme.name === 'dark' ? '#e2e8f0' : '#334155')};
  transition: all 0.2s ease;
  cursor: ${(props) => (props.interactive ? 'pointer' : 'default')};

  ${(props) =>
    props.interactive &&
    `
    &:hover {
      background: ${
        props.theme.name === 'dark'
          ? 'rgba(255, 255, 255, 0.08)'
          : 'rgba(250, 70, 22, 0.05)'
      };
      border-color: ${props.theme?.colors?.primary || '#fa4616'};
      transform: translateY(-2px);
    }
  `}
`;

// Badge version without hover effects for display-only info
export const PatternBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(255, 255, 255, 1)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.08)'};
  border-radius: 20px;
  font-size: 14px;
  color: ${(props) => (props.theme.name === 'dark' ? '#e2e8f0' : '#334155')};
`;

export const PillCount = styled.span`
  background: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
`;

export const PatternHighlight = styled.div`
  padding: 16px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : 'rgba(250, 70, 22, 0.05)'};
  border-radius: 8px;
  margin-top: 16px;
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark' ? 'transparent' : 'rgba(250, 70, 22, 0.1)'};
`;

export const PatternLabel = styled.div`
  font-size: 14px;
  color: ${(props) => (props.theme.name === 'dark' ? '#cbd5e1' : '#64748b')};
  margin-bottom: 8px;
`;

export const PatternValue = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
`;

export const PatternSection = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PatternSectionTitle = styled.h4`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${(props) => (props.theme.name === 'dark' ? '#cbd5e1' : '#64748b')};
  margin-bottom: 12px;
`;

// Quick Actions Card
export const QuickActionsCard = styled(SidebarCard)``;

export const QuickActionsTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 20px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  background: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #e03a0d;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(250, 70, 22, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SecondaryButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  background: transparent;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.3);
  }
`;

export const TextButton = styled.button`
  width: 100%;
  padding: 8px 0;
  background: transparent;
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  border: none;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.15s ease;
  text-align: center;

  &:hover {
    color: #e03a0d;
  }
`;

// Utility exports for missing components
export const StatsSection = styled.div``;
export const StatItem = styled.div``;
export const StatLabel = styled.div``;
export const StatValue = styled.div``;
export const StatSubtext = styled.div``;

// Educational Drawer Section component (used for content inside the reusable EducationDrawer)
export const DrawerSection = styled.div`
  margin-bottom: 28px;
  padding-bottom: 28px;
  border-bottom: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.08)'
        : 'rgba(0,0,0,0.08)'};

  &:last-of-type {
    border-bottom: none;
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: ${(props) =>
      props.theme.name === 'dark' ? '#ffffff' : 'props.theme.colors.blueBlack'};
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  p {
    margin-bottom: 12px;
    line-height: 1.5;
    font-size: 16px;
  }
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
`;

export const HabitGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-top: 12px;
`;

export const HabitItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.03)'
      : 'rgba(0,0,0,0.02)'};
  border-radius: 8px;
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.08)'
        : 'rgba(0,0,0,0.06)'};
`;

export const HabitIcon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(250, 70, 22, 0.15)'
      : 'rgba(250, 70, 22, 0.1)'};
  border-radius: 8px;
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  flex-shrink: 0;
`;

export const HabitContent = styled.div`
  flex: 1;
`;

export const HabitTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : 'props.theme.colors.blueBlack'};
  margin-bottom: 4px;
`;

export const HabitDescription = styled.div`
  font-size: 13px;
  line-height: 1.4;
  color: ${(props) => (props.theme.name === 'dark' ? '#94a3b8' : '#64748b')};
`;

export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: rgba(250, 70, 22, 0.1);
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  margin-left: 4px;
`;

export const HelpButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  margin-left: 12px;
  cursor: pointer;
  color: ${(props) => (props.theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  transition: all 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  position: relative;
  top: -1px;

  &:hover {
    color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
    transform: scale(1.1);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const PatternsTitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  position: relative;
`;
